import React from 'react';

import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { Promocode } from 'types/state/promocode';
import { normalizeProfileLike } from 'utils/profileLikeUtils';
import { TooltipComponent } from 'design/tooltip/tooltipComponents';
import { writeToClipboard } from 'utils/clipboardUtils';
import { setCustomTimeout } from 'utils/setCustomTimeout';
import { SECOND_MS } from 'utils/constants';

type Props = {
  promocode: Promocode;
  active: boolean;
  onClick(id: number): void;
};

export const PromocodesTableRow = (props: Props) => {
  const { promocode, active, onClick } = props;

  const {
    promocodesTableColumns: ownDictionary,
    shared: sharedDictionary,
  } = useIntlDictionary();

  const [hasTooltip, setHasTooltip] = React.useState(false);

  const copyPromocodeValueToClipboard = React.useCallback(() => {
    writeToClipboard(promocode.value).then(() => {
      setHasTooltip(true);
    });
  }, [promocode.value]);

  const onRowClick = React.useCallback(() => {
    copyPromocodeValueToClipboard();

    onClick(promocode.id);
  }, [copyPromocodeValueToClipboard, onClick, promocode.id]);

  React.useEffect(() => {
    if (hasTooltip) {
      return setCustomTimeout(() => {
        setHasTooltip(false);
      }, SECOND_MS * 1.5);
    }
  }, [hasTooltip]);

  return (
    <>
      <TableTr
        id={`${promocode.id}`}
        secondary={promocode.activatedAtTimestamp !== null}
        active={active}
        blinking={hasTooltip}
        onClick={onRowClick}
      >
        <TableTd text={`${promocode.id}`} />
        <TableTd text={ownDictionary.promocodeValueText(promocode)} />
        <TableTd text={promocode.org ? promocode.org.name : '-'} />
        <TableTd
          text={
            promocode.person
              ? normalizeProfileLike(promocode.person).toFullName()
              : '-'
          }
        />
        <TableTd
          text={sharedDictionary.dates.calendarDate(
            new Date(promocode.createdAtTimestamp)
          )}
        />
        <TableTd text={ownDictionary.statusValueText(promocode)} />
        <TableTd
          text={
            promocode.activatedAtTimestamp !== null
              ? sharedDictionary.dates.calendarDateWithTime(
                  new Date(promocode.activatedAtTimestamp)
                )
              : '-'
          }
        />
        <TableTd
          text={sharedDictionary.dates.calendarDate(
            new Date(promocode.extiresAtTimestamp)
          )}
        />
      </TableTr>
      <div
        style={{
          position: 'relative',
          left: '87.5px',
          top: '-20px',
        }}
      >
        <TooltipComponent visible={hasTooltip}>
          {sharedDictionary.partnerCodeTooltipText}
        </TooltipComponent>
      </div>
    </>
  );
};
